import { render, staticRenderFns } from "./BlockListContactPersons.vue?vue&type=template&id=ff23caba&"
import script from "./BlockListContactPersons.vue?vue&type=script&lang=js&"
export * from "./BlockListContactPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports